import { Form, Head, usePage } from '@inertiajs/react'

import { AppShell } from '@/layouts/app-shell'
import { Button } from '@/components/ui/button'
import { selectDashboardOrganizationPath } from '@/routes'

type Organization = {
  id: string
  name: string
  slug: string
  logo?: string | null
}

type Repository = {
  id: string
  fullName: string
  name?: string
}

type Props = {
  organizations: Organization[]
  repositories?: Repository[]
}

export default function DashboardShow({ organizations, repositories = [] }: Props) {
  const { flash } = usePage().props

  return (
    <>
      <Head title="Choose a workspace" />
      <AppShell>
        <h1 className="mb-8 text-center text-2xl">Choose a workspace</h1>
        <div className="mx-auto flex w-full max-w-lg flex-col gap-3">
          {(flash?.alert || flash?.notice) && (
            <p className={`text-center text-sm ${flash.alert ? 'text-red-600' : 'text-golden-700'}`}>
              {flash.alert || flash.notice}
            </p>
          )}

          {organizations.length === 0 ? (
            <p className="text-muted-foreground text-center text-sm">
              No workspace is linked to this GitHub account yet. Contact support if you expect access.
            </p>
          ) : null}

          {organizations.map((org) => (
            <Form key={org.id} method="post" action={selectDashboardOrganizationPath(org.id)}>
              {({ processing }) => (
                <Button
                  type="submit"
                  variant="outline"
                  disabled={processing}
                  className="h-auto w-full justify-start gap-3 px-4 py-3"
                >
                  {org.logo ? (
                    <img src={org.logo} alt="" className="h-8 w-8 rounded" />
                  ) : (
                    <span className="bg-muted flex h-8 w-8 items-center justify-center rounded text-xs font-semibold">
                      {org.name.slice(0, 2).toUpperCase()}
                    </span>
                  )}
                  <span className="text-left">
                    <span className="block font-medium">{org.name}</span>
                    <span className="text-muted-foreground block text-xs">{org.slug}</span>
                  </span>
                </Button>
              )}
            </Form>
          ))}

          {repositories.length > 0 ? (
            <p className="text-muted-foreground mt-4 text-center text-xs">
              {repositories.length} repositories available after you pick a workspace.
            </p>
          ) : null}
        </div>
      </AppShell>
    </>
  )
}
